import axios from "axios";

const host = typeof BROWSER_ENV === "undefined" ? "https://api.mailtop.com.br/v1/" : "";
export default axios.create({
    baseURL: host,
    withCredentials: true
});